module.exports = __webpack_public_path__ + "static/media/icon_certificate.4dd8b528.svg";